// extracted by mini-css-extract-plugin
module.exports =  {"clickable":"NavigationChip-module_clickable__S8PQIiUjU4MNTbLuDReg"};